import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from 'minimal-ui';
import { Iconify } from 'minimal-ui';

const DiscardChangesDialog = ({ open, onClose, onDiscard }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Iconify icon="eva:alert-triangle-fill" sx={{ color: 'warning.main', width: 24, height: 24 }} />
                Discard Changes?
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    You have unsaved product swap changes. If you close now, these changes will be lost. Do you want to discard them and close?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    onClick={onDiscard}
                    variant="contained"
                    color="error"
                    sx={{
                        '&.MuiButton-root': {
                            backgroundColor: '#E27172',
                            color: 'white',
                        }
                    }}
                >
                    Discard & Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DiscardChangesDialog;

